import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pick',
})
export class PickPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any, key: string): any;
  transform<T, K extends keyof T>(array: T[], key: K): T[K][] {
    return array.map((item) => item[key]);
  }
}
